export default __webpack_public_path__ + "static/media/softwareWork.4833d611.png";